import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { firebaseApp, isFirebaseConfigured } from '../firebase/config';

export const DEMO_EMAIL = process.env.REACT_APP_DEMO_ADMIN_EMAIL || 'admin@jatin.com';
export const DEMO_PASSWORD = process.env.REACT_APP_DEMO_ADMIN_PASSWORD || 'jatin@123';

const AUTH_PROVIDER_KEY = 'auth_provider';

export function getLoginErrorMessage(err) {
  if (err?.code?.startsWith?.('auth/')) {
    const map = {
      'auth/invalid-email': 'Invalid email address.',
      'auth/user-disabled': 'This account has been disabled.',
      'auth/user-not-found': 'No account found for this email.',
      'auth/wrong-password': 'Incorrect password.',
      'auth/invalid-credential': 'Invalid email or password.',
    };
    return map[err.code] || err.message || 'Login failed.';
  }
  return err?.message || 'Login failed. Please try again.';
}

/**
 * @returns {Promise<{ ok: true } | { ok: false, error: string }>}
 */
export async function attemptAdminLogin(rawEmail, password) {
  const email = rawEmail.trim();
  const demoEmailMatch = email.toLowerCase() === DEMO_EMAIL.toLowerCase();

  if (demoEmailMatch && password === DEMO_PASSWORD) {
    const token = btoa(`${email}:${Date.now()}`);
    localStorage.setItem('token', token);
    localStorage.setItem('user_data', JSON.stringify({ email, name: 'Admin' }));
    localStorage.setItem(AUTH_PROVIDER_KEY, 'demo');
    return { ok: true };
  }

  if (isFirebaseConfigured() && firebaseApp) {
    try {
      const auth = getAuth(firebaseApp);
      const cred = await signInWithEmailAndPassword(auth, email, password);
      const token = await cred.user.getIdToken();
      localStorage.setItem('token', token);
      localStorage.setItem(AUTH_PROVIDER_KEY, 'firebase');
      localStorage.setItem(
        'user_data',
        JSON.stringify({
          email: cred.user.email,
          uid: cred.user.uid,
          displayName: cred.user.displayName || '',
        })
      );
      return { ok: true };
    } catch (err) {
      console.error('Login error:', err);
      return { ok: false, error: getLoginErrorMessage(err) };
    }
  }

  return { ok: false, error: 'Invalid email or password.' };
}
